import { FANTASY_LABELS, LeagueSettingsStarters } from '@pff-consumer/schema'
import { sortByDraftRoomStarterMap } from './sort-by-draft-room-starter-map'

export const getRosterPositions = (startingLeagueSettings: LeagueSettingsStarters) => {
  const rosterData = sortByDraftRoomStarterMap([], startingLeagueSettings, 0)
  const rosterPositions = new Set(rosterData.map((item) => item.rosterPosition))
  const filteredPlayerPositions = FANTASY_LABELS.POSITIONS.filter((position) => rosterPositions.has(position.value))
  return filteredPlayerPositions
}
